import React from 'react';
import { Card, CardBody, CardTitle, Col } from 'reactstrap';

//Helpers
import { formatarValorIndicador } from '../helpers/gerenciamentoFiscalizacao';

// Cards de indicadores do Gerenciamento de Fiscalização.
// Recebe a lista já montada pela tela (sem chamada à API).
function CardIndicadores({ indicadores = [] }) {
    return <>
        {indicadores.map((indicador, key) => {
            //Indicadores de boleto exibem o valor no corpo e a quantidade no título.
            //Indicadores de quantidade exibem a própria quantidade no corpo.
            const exibeValor = indicador.valor !== undefined;

            return (
                // d-flex + h-100 mantêm todos os cards com a mesma altura.
                <Col md={12} lg={3} key={key} className='mb-3 d-flex'>
                    <Card
                        className="p-3 shadow rounded text-center text-white h-100 w-100"
                        style={{
                            border: "none",
                            backgroundColor: indicador.cor
                        }}
                    >
                        <CardTitle tag="h6" className="mb-0 mb-2 d-flex justify-content-between align-items-center">
                            <span className='d-block fw-bold h5'>{indicador.titulo}</span>
                            {exibeValor &&
                                <span className='d-block fw-bold h5'>{indicador.quantidade ?? 0}</span>
                            }
                        </CardTitle>
                        <CardBody className="p-0 mb-0 h2 d-flex align-items-center justify-content-center">
                            {exibeValor
                                ? formatarValorIndicador(indicador.valor)
                                : (indicador.quantidade ?? 0)}
                        </CardBody>
                    </Card>
                </Col>
            );
        })}
    </>;
}

export default CardIndicadores;
